export default function SiteIcon(domain: string) {
  return domain.length > 0
    ? "https://www.google.com/s2/favicons?domain=" + domain + "/favicon.ico"
    : "";
}
